<template>
    <div class="confirmKeyword">
        <el-row>
            <selectMenu fatherComponent="confirmKeyword" @getWidth="getWidth" @getselectedItem="getselectedItem"
                :proArr="promotion" :selectedval="selectedval" :selecteditem="selecteditem"></selectMenu>
            <div class="bodyMain" :style="{ marginLeft: width + 10 + 'px', width: boxWidth + 'px' }">
                <el-row :gutter="22">
                    <el-col class="el_col" :span="12">
                        <div class="main-title">确认关键词</div>
                        <div class="sub_title">谷歌关键词数据报告说明</div>
                        <div>
                            <span>位置范围：全球</span>
                            <span style="margin: 0 80px 0 80px">语言：英语</span>
                            <span class="el_col">日期范围：过去12个月</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="margin-top:15px">
                        <prodDisplay v-if="selecteditem.type === 1" :imgUrl="selecteditem.imgPath"
                            :title="selecteditem.title" :domain="selecteditem.domain"></prodDisplay>
                    </el-col>
                </el-row>
                <el-row>
                    <proKeywords :automationContentId="selecteditem.automationContentId" :domain="selecteditem.domain" :keywordsList="keywordsList" :excludedKeywordsList="removeKeywordList" :load="load"></proKeywords>
                </el-row>
            </div>
        </el-row>
        <confirmStep :activeValue="3" @toNext="toNext" @toPrev="toPrev" @toSkip="toSkip" class="footer"></confirmStep>
    </div>
</template>
<script>
import proKeywords from '@/components/adsOnlineAuto/com/proKeywords.vue';
import selectMenu from '@/components/adsOnlineAuto/com/selectMenu.vue';
import confirmStep from '@/components/adsOnlineAuto/confirmStep';
import prodDisplay from '@/components/adsOnlineAuto/com/prodDisplay.vue';
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js'
export default {
    components: {
        proKeywords,
        selectMenu,
        confirmStep,
        prodDisplay
    },
    props: ['activeValue'],
    data() {
        return {
            boxWidth: document.documentElement.clientWidth - 510,
            width: 260,
            promotion: [],
            selectedval: '',
            selecteditem: {},
            removeKeywordList: [],
            keywordsList: [],
            load: true,
            id: '',
            automationContentId:"",
        };
    },
    computed: {
        queryParam() {
            return this.$route.query;
        },
    },
    methods: {
        async getproduct() {
            let res = await adsNewOnlineSer.getproduct({
                id: this.id
            });
            this.promotion = res.data.productList.concat(res.data.productTypeList);
        },
        async generate_keyword(obj) {
            try {
                let res = await adsNewOnlineSer.generate_keyword({
                url: obj.domain
                }, { serviceSiteId: this.queryParam.serviceSiteId });
                this.keywordsList = res.data;
                this.removeKeywordList = [];
                this.load = false;
            } catch (error) {
                this.load = false;
            }
        },
        async productkeyword(obj) {
            try {
                let res = await adsNewOnlineSer.productkeyword({
                automationContentId: obj.automationContentId,
                automationId: this.id
                });
                this.keywordsList = res.data.allKeywordList;
                this.removeKeywordList = res.data.removeKeywordList;
                this.load = false;
            } catch (error) {
                this.load = false;
            }
        },
        async addproductkeyword(obj,showFlag) {
            // let automationContentId = obj.automationContentId;
            let res = await adsNewOnlineSer.addproductkeyword({
                automationContentId: this.automationContentId,
                automationId: this.id,
                allKeywordList: this.keywordsList,
                removeKeywordList: this.removeKeywordList,
                showFlag: showFlag ? 1 : 0,
            });
            return (res.data);
        },
        getselectedItem(val, arr) {
            if (arr.length == 1) {
                this.addproductkeyword(this.promotion[0])
            } else {
                this.addproductkeyword(arr[arr.length - 2]);
            }
            this.automationContentId=val.automationContentId;
            this.getproduct().then(async () => {
                this.selecteditem = val;
                if (this.selecteditem.keywordFlag === 0) {
                    this.generate_keyword(this.selecteditem);
                } else {
                    this.productkeyword(this.selecteditem);
                }
            });
        },
        getWidth(boxWidth, width) {
            this.boxWidth = boxWidth;
            this.width = width;
        },
        toNext(param) {
            if (this.promotion.findIndex(target => target.keywordFlag === 0) == -1 || this.promotion[this.promotion.length - 1] === this.selecteditem) {
                this.automationContentId=this.selecteditem.automationContentId;
                this.addproductkeyword(this.selecteditem,param);
                this.$store.dispatch('getstepstatus',this.id);
                        if(param)
                        {
                            this.$emit('toSkip', 6);
                        }else{
                            this.$emit('toNext');
                        }
            } else {
                this.automationContentId=this.selecteditem.automationContentId;
                this.addproductkeyword(this.selecteditem).then(async () => {
                    this.getproduct().then(async () => {
                        let index = this.promotion.findIndex((obj) => obj.automationContentId == this.selecteditem.automationContentId);
                        this.selecteditem = this.promotion[index + 1];
                        this.automationContentId=this.selecteditem.automationContentId;
                        this.selectedval = this.selecteditem.automationContentId
                        if (this.selecteditem.keywordFlag === 0) {
                            this.generate_keyword(this.selecteditem);
                        } else {
                            this.productkeyword(this.selecteditem);
                        }
                    });
                });
            }
        },
        toPrev() {
            if (this.promotion[0] === this.selecteditem) {
                this.$emit('toPrev');
            } else {
                let index = this.promotion.indexOf(this.selecteditem);
                this.selecteditem = this.promotion[index - 1];
                this.selectedval = this.selecteditem.automationContentId
                if (this.selecteditem.keywordFlag === 0) {
                    this.generate_keyword(this.selecteditem);
                } else {
                    this.productkeyword(this.selecteditem);
                }
            }
        },
        toSkip() {
            this.toNext(1);
            // this.$emit('toSkip', 6);
        },
        requestData() {
            this.getproduct().then(async () => {
                this.selecteditem = this.promotion[0];
                this.selectedval = this.selecteditem.automationContentId;
                this.automationContentId=this.selectedval;
                if (this.selecteditem.keywordFlag === 0) {
                    this.generate_keyword(this.selecteditem);
                } else {
                    this.productkeyword(this.selecteditem);
                }
            });
        }
    },
    watch: {
    },
    created() {
        this.id = this.$route.query.id;
        this.requestData();
    },
    beforeDestroy() {
        this.automationContentId=this.selecteditem.automationContentId;
        this.addproductkeyword(this.selecteditem);
    }
}
</script>
<style lang="scss" scoped>
.confirmKeyword {
    .bodyMain {
        background-color: #ffffff;
        height: 1000px;
        margin-bottom: 10px;
        .el-col {
            margin-left: 30px;

            .main-title {
                margin: 20px 0 20px 0;
                font-size: 18px;
                font-weight: 600;
            }

            .sub_title {
                margin-bottom: 20px;
                font-size: 15px;
                font-weight: 500;
                color: #333333;
            }
        }
    }

    ::v-deep  .vdr.active::before {
        outline: none;
    }

    ::v-deep .vdr-stick {
        border: unset;
        background: unset;
        box-shadow: unset;
        -webkit-box-shadow: unset;
    }

    ::v-deep .vdr-stick-mr {
        width: 30px !important;
        height: 30px !important;
        margin-top: 17px !important;
        right: 10px !important;
    } 
    ::v-deep .selectMenu .VueDragResize .aside {
        height: 1000px;
    }
    ::v-deep .selectMenu .VueDragResize .aside .areaItem{
        height: 920px;
    }
}
</style>
